import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  OFLC_ACCEPTE_INVITATION,
  acceptInvitationSuccess,
  acceptInvitationFail,
} from "../actions/action_acceptInvitation";
import util from "../../../global/utils/Helpers";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = (invitation) => {
  return JSON.stringify({
    query: `
            mutation {
                acceptInvitation(email:"${invitation.recipientEmail}",group_id:"${invitation.groupId}")
          }`,
  });
};
const rejectUserDataEpic = (action$) =>
  action$.pipe(
    ofType(OFLC_ACCEPTE_INVITATION),
    mergeMap((action) =>
      fetch(apiIndex, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data.acceptInvitation === 403) {
            return acceptInvitationFail(data);
          }
          return acceptInvitationSuccess(data);
        })
        .catch((error) => acceptInvitationFail(true))
    )
  );

export default rejectUserDataEpic;
